import { useEffect } from 'react'

/**
 * Hook that schedules a callback to run after two requestAnimationFrame cycles.
 *
 * This ensures the browser has painted the initial state before the callback runs,
 * which is useful for animations that need to transition from one state to another
 * without the intermediate state being visible.
 *
 * Usage:
 *   useDoubleRAF(() => setExpanded(true), [dependency1, dependency2])
 *
 * @param {Function} callback - The function to call after two animation frames
 * @param {Array} dependencies - Dependency array (like useEffect)
 */
export default function useDoubleRAF(callback, dependencies = []) {
  useEffect(() => {
    let mounted = true

    // First rAF schedules the second
    requestAnimationFrame(() => {
      // Second rAF runs the callback after browser paints
      requestAnimationFrame(() => {
        if (mounted) {
          callback()
        }
      })
    })

    return () => {
      mounted = false
    }
  }, dependencies)
}
